import { render, staticRenderFns } from "./userSettingSideBar.vue?vue&type=template&id=12c5c048&scoped=true&"
import script from "./userSettingSideBar.vue?vue&type=script&lang=js&"
export * from "./userSettingSideBar.vue?vue&type=script&lang=js&"
import style0 from "./userSettingSideBar.vue?vue&type=style&index=0&id=12c5c048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5c048",
  null
  
)

export default component.exports